export const RoleTypeIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='12'
    fill='none'
    viewBox='0 0 17 12'
  >
    <path
      stroke='#757575'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M15.65 11.029v-1.58c0-.943-.763-1.705-1.705-1.705H13.4M.65 11.029v-1.58c0-.943.764-1.705 1.705-1.705h.547m8.89 3.285V9.104a2.386 2.386 0 0 0-2.387-2.387H6.895A2.386 2.386 0 0 0 4.51 9.104v1.925m9.636-7.295a1.38 1.38 0 1 1-1.951 1.95 1.38 1.38 0 0 1 1.95-1.95M9.652 1.272a2.124 2.124 0 1 1-3.004 3.004 2.124 2.124 0 0 1 3.004-3.004M4.106 3.734a1.38 1.38 0 1 1-1.951 1.95 1.38 1.38 0 0 1 1.95-1.95'
    ></path>
  </svg>
);
